// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select-wrapper[data-v-4d5905d0] {
  display: flex;
  width: 100%;
  border-bottom: 1px solid var(--asc-item-border-bottom);
  font-size: 16px;
}
.custom-select-wrapper.required[data-v-4d5905d0] {
  border-bottom: 1px solid var(--elem-red-color);
  animation: vibra-4d5905d0 .09s 5 linear;
}
.custom-select-wrapper label[data-v-4d5905d0] {
  z-index: 0;
  font-size: 1em;
  font-weight: 500;
  color: var(--custom-textarea-color);
  margin: 5px;
  cursor: pointer;
  min-width: fit-content;
}
.custom-select-wrapper select[data-v-4d5905d0] {
  padding-right: 10px !important;
  padding-left: 4px !important;
  -webkit-padding-start: 4px !important;
  -webkit-padding-end: 10px !important;
}
.custom-select-wrapper .arrow[data-v-4d5905d0] {
  margin: auto 0 auto auto;
  pointer-events: none;
  cursor: pointer;
  transform: translateX(-10px);
}
.custom-select-wrapper .clear[data-v-4d5905d0] {
  margin: auto 0 auto auto;
  pointer-events: auto;
  display: flex;
  flex: 1 1;
  cursor: pointer;
  transform: translate(-10px, 1px);
}
.custom-select-wrapper.down[data-v-4d5905d0]::before {
  content: attr(data-label);
  position: absolute;
  pointer-events: none;
  margin: auto 5px;
  transform: translateY(7px);
  color: #aaa;
  transition-property: all;
  transition-duration: .25s;
}
.custom-select-wrapper.up[data-v-4d5905d0]::before {
  margin: auto 5px;
  content: attr(data-label);
  position: absolute;
  transform: translateY(-15px);
  font-size: 0.8em;
  transition-property: all;
  transition-duration: .25s;
  color: #aaa;
}
.custom-select-wrapper .select-label[data-v-4d5905d0] {
  position: absolute;
  cursor: pointer;
  margin: 5px;
}
.custom-select-wrapper .custom-select[data-v-4d5905d0] {
  z-index: 100;
  width: 100%;
  display: flex;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  border: none;
  background: transparent;
  transition-property: all;
  transition-duration: .25s;
  cursor: pointer;
  outline: none;
  font-size: 1em;
  color: var(--dropdown-color);
  margin: 5px;
}
.custom-select-wrapper .custom-select.up[data-v-4d5905d0] {
  transition-property: all;
  transition-duration: .5s;
  opacity: 1;
}
.custom-select-wrapper .custom-select[data-v-4d5905d0]:disabled {
  color: var(--placeholder-color);
  cursor: default;
}
.custom-select-wrapper .custom-select:disabled + svg[data-v-4d5905d0] {
  fill: var(--placeholder-color);
}
@keyframes vibra-4d5905d0 {
50% {
    transform: translateX(-1px);
}
100% {
    transform: translateX(1px);
}
}
@keyframes up-4d5905d0 {
100% {
    transform: translateY(-15px);
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/custom/CustomSelect.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,sDAAsD;EACtD,eAAe;AACjB;AACA;EACE,8CAA8C;EAC9C,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,qCAAqC;EACrC,oCAAoC;AACtC;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;EACX,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;AACA;AACA;AACA;IACI,4BAA4B;AAChC;AACA","sourcesContent":[".custom-select-wrapper[data-v-4d5905d0] {\n  display: flex;\n  width: 100%;\n  border-bottom: 1px solid var(--asc-item-border-bottom);\n  font-size: 16px;\n}\n.custom-select-wrapper.required[data-v-4d5905d0] {\n  border-bottom: 1px solid var(--elem-red-color);\n  animation: vibra-4d5905d0 .09s 5 linear;\n}\n.custom-select-wrapper label[data-v-4d5905d0] {\n  z-index: 0;\n  font-size: 1em;\n  font-weight: 500;\n  color: var(--custom-textarea-color);\n  margin: 5px;\n  cursor: pointer;\n  min-width: fit-content;\n}\n.custom-select-wrapper select[data-v-4d5905d0] {\n  padding-right: 10px !important;\n  padding-left: 4px !important;\n  -webkit-padding-start: 4px !important;\n  -webkit-padding-end: 10px !important;\n}\n.custom-select-wrapper .arrow[data-v-4d5905d0] {\n  margin: auto 0 auto auto;\n  pointer-events: none;\n  cursor: pointer;\n  transform: translateX(-10px);\n}\n.custom-select-wrapper .clear[data-v-4d5905d0] {\n  margin: auto 0 auto auto;\n  pointer-events: auto;\n  display: flex;\n  flex: 1 1;\n  cursor: pointer;\n  transform: translate(-10px, 1px);\n}\n.custom-select-wrapper.down[data-v-4d5905d0]::before {\n  content: attr(data-label);\n  position: absolute;\n  pointer-events: none;\n  margin: auto 5px;\n  transform: translateY(7px);\n  color: #aaa;\n  transition-property: all;\n  transition-duration: .25s;\n}\n.custom-select-wrapper.up[data-v-4d5905d0]::before {\n  margin: auto 5px;\n  content: attr(data-label);\n  position: absolute;\n  transform: translateY(-15px);\n  font-size: 0.8em;\n  transition-property: all;\n  transition-duration: .25s;\n  color: #aaa;\n}\n.custom-select-wrapper .select-label[data-v-4d5905d0] {\n  position: absolute;\n  cursor: pointer;\n  margin: 5px;\n}\n.custom-select-wrapper .custom-select[data-v-4d5905d0] {\n  z-index: 100;\n  width: 100%;\n  display: flex;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  border: none;\n  background: transparent;\n  transition-property: all;\n  transition-duration: .25s;\n  cursor: pointer;\n  outline: none;\n  font-size: 1em;\n  color: var(--dropdown-color);\n  margin: 5px;\n}\n.custom-select-wrapper .custom-select.up[data-v-4d5905d0] {\n  transition-property: all;\n  transition-duration: .5s;\n  opacity: 1;\n}\n.custom-select-wrapper .custom-select[data-v-4d5905d0]:disabled {\n  color: var(--placeholder-color);\n  cursor: default;\n}\n.custom-select-wrapper .custom-select:disabled + svg[data-v-4d5905d0] {\n  fill: var(--placeholder-color);\n}\n@keyframes vibra-4d5905d0 {\n50% {\n    transform: translateX(-1px);\n}\n100% {\n    transform: translateX(1px);\n}\n}\n@keyframes up-4d5905d0 {\n100% {\n    transform: translateY(-15px);\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
